function Storage() {

	const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

	if ( indexedDB === undefined ) {

		console.warn( 'Storage: IndexedDB not available.' );
		return { init: function () {}, get: function () {}, set: function () {}, clear: function () {} };

	}

	const name = 'threejs-editor';
	const version = 1;

    /** @type {IDBDatabase} */
	let database;

	return {

		init: function ( callback ) {

			const request = indexedDB.open( name, version );
			request.onupgradeneeded = function ( event ) {

				const db = event.target.result;

				if ( db.objectStoreNames.contains( 'states' ) === false ) {

					db.createObjectStore( 'states' );

				}

			};

			request.onsuccess = function ( event ) {

				database = event.target.result;

				callback();

			};

			request.onerror = function ( event ) {

				console.error( 'IndexedDB', event );

			};


		},

		get: function ( callback ) {

			const transaction = database.transaction( [ 'states' ], 'readwrite' );
			const objectStore = transaction.objectStore( 'states' );
			const request = objectStore.get( 0 );
			request.onsuccess = function ( event ) {
				const result = event.target.result;
                if (typeof result === 'string') {
                    try {
                        callback( JSON.parse(result) );
                    } catch (error) {
                        console.error('Storage.get: Error deserialising saved project.', error);
                    }
                } else if (typeof result === 'object') {
                    callback(result);
                } else {
                    console.error('Storage.get: Unsupported saved project format.', result);
                }
			};

		},

        getSize: function( callback ) {
			const transaction = database.transaction( [ 'states' ], 'readonly' );
			const objectStore = transaction.objectStore( 'states' );
            const request = objectStore.get(0);
            let sizeBytes = 0;
            request.onsuccess = function(event){
                callback(event.target.result.length)
            }.bind(this);
            request.onerror = function(err){
                console.error('Storage.getSize error: ', err);
            }
        },

		set: function ( data, callback ) {

			const start = performance.now();

			const transaction = database.transaction( [ 'states' ], 'readwrite' );
			const objectStore = transaction.objectStore( 'states' );

            let toSave;
            if (typeof data === 'string') {
                toSave = data;
            } else if (typeof data === 'object') {
                try {
                    toSave = JSON.stringify(data);;
                } catch (error) {
                    console.error('Storage.set: Error serialising project for save.', error);
                }
            } else {
                console.error('Storage.set: Unsupported format to save project.', data);
                return;
            }

			const request = objectStore.put( toSave, 0 );
			request.onsuccess = function () {

				console.log( '[' + /\d\d\:\d\d\:\d\d/.exec( new Date() )[ 0 ] + ']', 'Saved state to IndexedDB. ' + ( performance.now() - start ).toFixed( 2 ) + 'ms' );

			};

			callback( toSave.length );
		},

		clear: function () {

			if ( database === undefined ) return;

			const transaction = database.transaction( [ 'states' ], 'readwrite' );
			const objectStore = transaction.objectStore( 'states' );
			const request = objectStore.clear();
			request.onsuccess = function () {

				console.log( '[' + /\d\d\:\d\d\:\d\d/.exec( new Date() )[ 0 ] + ']', 'Cleared IndexedDB.' );

			};

		}

	};

}

export { Storage };
